import React from 'react';
import styled from 'styled-components';
import { PATH_KEY_TO_POSITION } from '../../constants';
import AddButton from '../shared/AddButton';
import RaisedPanel from '../shared/RaisedPanel';
import VariantEditor from './variant-editor';

const LEVEL = PATH_KEY_TO_POSITION['variantIdx'];

const VariantEditorsContainer = styled.div``;
const AddButtonContainer = styled.div`
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #dedede;
`;

function VariantEditorList(props) {
  const { variants, onAdd, onChange, onRemove, onEditorSetup, childErrors } =
    props;

  const handleAddVariant = () =>
    onAdd({ status: 'draft', type: 'variant', variantType: 'single' });

  if (!variants || variants.length === 0) {
    return null;
  }

  return (
    <RaisedPanel level={LEVEL}>
      <VariantEditorsContainer>
        {(variants || []).map(variant => (
          <VariantEditor
            key={`variant-editor-${variant.id}`}
            variant={variant}
            error={childErrors[variant.id]}
            onChange={v => onChange(v)}
            onRemove={v => onRemove(v)}
            onEditorSetup={v => onEditorSetup(v)}
          />
        ))}
      </VariantEditorsContainer>
      <AddButtonContainer>
        <AddButton onClick={handleAddVariant}>
          {variants && variants.length > 0
            ? 'Add more customisation options'
            : 'Add customisation options'}
        </AddButton>
      </AddButtonContainer>
    </RaisedPanel>
  );
}

export default VariantEditorList;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/ProductList/variant-editor-list.jsx